<template>
    <div class="blog-more-posts" v-if="posts && posts.length > 0">
        <div class="blog-more-posts-title">
            Mais postagens
        </div>
        <div v-for="post in posts_list" :key="post.id" class="mb-2">
            <nuxt-link :to="post.route">
                <b-row>
                    <b-col cols="6">
                        <div class="aspect-ratio ratio-4-3">
                            <div class="aspect-content">
                                <img class="object-fit-cover" v-lazy="imageUrl(post.image)" :alt="post.title">
                            </div>
                        </div>
                    </b-col>
                    <b-col cols="6">
                        <div class="blog-more-posts-datetime">
                            {{ $dayjs(post.datetime).format('LL') }}
                        </div>
                        <div class="blog-more-posts-post-title">
                            {{ post.title }}
                        </div>
                    </b-col>
                </b-row>
            </nuxt-link>
        </div>
    </div>
</template>
<script>
import utils from '~/mixins/utils';
export default {
    mixins: [utils],
    props:[
        'current_id'
    ],
    data(){
        return{
            posts: []
        }
    },
    computed:{
        posts_list: function (){
            // console.log(this.current_id)
            return this.posts.filter(function(el) {
                return el.id;
            })
        }
    },
    async fetch(){
        await this.$axios.$get(`api/v1/blogs/posts?&blog_id=1&limit=3`).then((res)=>{
            try {
                this.posts = res.data
            } catch (e) {
                console.error(e)
            }
        }).catch((e) => {
            console.error(e)
        })
    }
}
</script>
